import img1 from "../images/event/event1.png";
import img2 from "../images/event/event2.png";
import img3 from "../images/event/event3.png";
const event = [
	{
		img: img1,
		title: "CESC",
		subtitle: "academic Conference",
		schedule: "October 31st - November 1st",
		btn__text: "Learn More",
		link: "http://cesc.io/",
	},
	{
		img: img2,
		title: "Game7 Summit",
		subtitle: "Conference",
		schedule: "November 2nd",
		btn__text: "Coming Soon",
		link: "",
	},
	{
		img: img3,
		title: "ETH San Francisco",
		subtitle: "World's Biggest Ethereum Hackathon",
		schedule: "November 4th - November 6th",
		btn__text: "Coming Soon",
		link: "",
	},
];
export default event;
